<template>
  <div>
    <div class="file is-right">
      <label class="file-label">
        <input
          class="file-input"
          type="file"
          name="resume"
          accept="image/*"
          multiple
          @change="e => uploadGalleryPhotos(e.target)"
        />
        <span class="file-cta">
          <span class="file-icon">
            <i class="fas fa-image"></i>
          </span>
          <span class="file-label">
            Upload Images
          </span>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "GalleryUploader",
  props: {},
  methods: {
    toggle(value) {
      this.$emit("toggle", !value);
    },
    uploadGalleryPhotos(e) {
      if (e.files) {
        Object.values(e.files).forEach(async file => {
          const formData = new FormData();
          let errorMSG;
          formData.append("files", file);
          await axios
            .post(process.env.VUE_APP_SERVER + "upload/", formData)
            .then(res => {
              if (res.data.message.indexOf("Success") > -1) {
                this.updateGalleryPhotos(file.name);
              } else {
                errorMSG = res.message;
              }
            })
            .catch(error => {
              console.error(error);
              this.$noty.error(
                "There was a problem uploading " +
                  file.name +
                  ". " +
                  errorMSG +
                  "."
              );
            });
        });
      } else {
        this.$noty.warning("No image selected.");
      }
    },
    updateGalleryPhotos(photos) {
      this.$emit("updateGallery", photos);
    }
  }
};
</script>
